(function () {
  'use strict';

  function cleanSlickAria(root) {
    (root || document).querySelectorAll('.slick-track[role]').forEach(function (el) {
      el.removeAttribute('role');
      el.removeAttribute('aria-label');
    });
    (root || document).querySelectorAll('.slick-dots').forEach(function (ul) {
      ul.removeAttribute('role');
      ul.querySelectorAll('li').forEach(function (li) {
        li.removeAttribute('role');
        li.removeAttribute('aria-selected');
        li.removeAttribute('aria-controls');
      });
    });
    (root || document).querySelectorAll('.slick-slide[aria-describedby]').forEach(function (el) {
      el.removeAttribute('aria-describedby');
    });
    (root || document).querySelectorAll('.slick-slide[role]').forEach(function (el) {
      el.removeAttribute('role');
    });
  }

  function schedule() {
    cleanSlickAria();
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && (t.closest ? t.closest('.slick-slider, .slick-dots') : null)) {
          cleanSlickAria(t.closest('.slick-slider') || document);
          break;
        }
      }
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['role', 'aria-selected', 'aria-controls'], subtree: true });
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
})();
